const API_URL = "https://ims.holdthechild.net"; // Update with your actual API URL
export const getToken = () => localStorage.getItem("token");

// Request a password reset link (Step 1)
export const requestPasswordReset = async (email) => {
  try {
    const res = await fetch(`${API_URL}/api/auth/request-reset`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.message || "Failed to send reset link");
    }

    return data;
  } catch (err) {
    console.error("Reset password request error:", err.message);
    throw err;
  }
};

// Verify the reset token (Step 2)
export const verifyResetToken = async ({ email, resetCode }) => {
  try {
    const res = await fetch(`${API_URL}/api/auth/verify-code`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, resetCode }), 
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Invalid or expired token");

    return data;
  } catch (err) {
    console.error("Verify reset token error:", err.message);
    throw err;
  }
};

// REVISED changePassword function to handle both flows
export const changePassword = async (email, oldPassword, newPassword, resetCode = null) => {
  const body = { email, newPassword };
  if (oldPassword) {
    body.oldPassword = oldPassword;
  }
  if (resetCode) {
    body.resetCode = resetCode;
  }

  try {
    const res = await fetch(`${API_URL}/api/auth/change-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.error || "Failed to change password");
    }

    return data; // This will now include the token and user data from the backend
  } catch (err) {
    console.error("Change password error:", err.message);
    throw err;
  }
};
